// extracted by mini-css-extract-plugin
module.exports = {"form_container":"ResetPasswordForm_form_container__29LNb","succeded_reset":"ResetPasswordForm_succeded_reset__3zn0w"};